import { AsyncPipe, Location } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { I18NEXT_SERVICE, I18NextModule, ITranslationService } from 'angular-i18next';
import { map, Observable } from 'rxjs';
import { BaseComponent } from 'src/app/_shared/components/base/base.component';
import { CardCarouselComponent } from 'src/app/_shared/components/card-carousel/card-carousel.component';
import { IconComponent } from 'src/app/common/icon/icon.component';
import { METADATA_SERVICE, MetadataService } from 'src/app/common/metadata/metadata.service';
import { User } from 'src/types/graphql';
import { FooterComponent } from '../../_shared/components/footer/footer.component';
import { HeaderComponent } from '../../_shared/components/header/header.component';
import { AllAmbassadorsGQL } from './ambassador.query.generated';
import { RouteTranslatePipe } from '../../_shared/pipes/route-translate.pipe';

@Component({
  selector: 'sharry-ambassador',
  templateUrl: './ambassador.component.html',
  styleUrls: ['./ambassador.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AsyncPipe,
    I18NextModule,
    MatButtonModule,
    CardCarouselComponent,
    IconComponent,
    RouterLink,
    RouteTranslatePipe,
    HeaderComponent,
    FooterComponent,
  ],
})
export class AmbassadorComponent extends BaseComponent implements OnInit, OnDestroy {
  list: { icon: string; title: string; subtitle: string }[] = [
    {
      icon: 'https://media.sharry.land/app/images/ambassador/ic-ispirano.webp',
      title: 'ambassador.do-1.title',
      subtitle: 'ambassador.do-1.subtitle',
    },
    {
      icon: 'https://media.sharry.land/app/images/ambassador/ic-raccontano.webp',
      title: 'ambassador.do-2.title',
      subtitle: 'ambassador.do-2.subtitle',
    },
    {
      icon: 'https://media.sharry.land/app/images/ambassador/ic-creano.webp',
      title: 'ambassador.do-3.title',
      subtitle: 'ambassador.do-3.subtitle',
    },
    {
      icon: 'https://media.sharry.land/app/images/ambassador/ic-segnalano.webp',
      title: 'ambassador.do-4.title',
      subtitle: 'ambassador.do-4.subtitle',
    },
    {
      icon: 'https://media.sharry.land/app/images/ambassador/ic-raggruppano.webp',
      title: 'ambassador.do-5.title',
      subtitle: 'ambassador.do-5.subtitle',
    },
    {
      icon: 'https://media.sharry.land/app/images/ambassador/ic-invitano.webp',
      title: 'ambassador.do-6.title',
      subtitle: 'ambassador.do-6.subtitle',
    },
  ];

  benefits: { title: string; subtitle: string }[] = [
    { title: 'ambassador.benefit-1.title', subtitle: 'ambassador.benefit-1.subtitle' },
    { title: 'ambassador.benefit-2.title', subtitle: 'ambassador.benefit-2.subtitle' },
    { title: 'ambassador.benefit-3.title', subtitle: 'ambassador.benefit-3.subtitle' },
    { title: 'ambassador.benefit-4.title', subtitle: 'ambassador.benefit-4.subtitle' },
    { title: 'ambassador.benefit-5.title', subtitle: 'ambassador.benefit-5.subtitle' },
    { title: 'ambassador.benefit-6.title', subtitle: 'ambassador.benefit-6.subtitle' },
  ];
  ambassadors$: Observable<User[]>;

  constructor(
    private cd: ChangeDetectorRef,
    private allAmbassadorsGQL: AllAmbassadorsGQL,
    @Inject(METADATA_SERVICE) private metadataService: MetadataService,
    private location: Location,
    @Inject(I18NEXT_SERVICE) private translationService: ITranslationService,
  ) {
    super();
    this.ambassadors$ = this.allAmbassadorsGQL.fetch({}).pipe(map(r => r.data.allUsers as User[]));
  }

  ngOnInit(): void {
    this.metadataService.setMetadataPage('ambassador', this.location.path());
    this.cd.detectChanges();
  }

  ngOnDestroy() {
    this.metadataService.clean();
  }
}
